import { TasksPage } from './TasksPage';

export function AdminTrilhasPage() {
  return <TasksPage />;
}
